// @ts-nocheck
export default function PlatformInMotion() {
  return (
    <>
<section className="motion-section" id="motionSection">
  <div className="motion-orb motion-orb-1"></div>
  <div className="motion-orb motion-orb-2"></div>

  <div className="motion-header">
    <div>
      <div className="ey ey-d rev">Platform in motion</div>
      <h2 className="motion-h rev d1">Watch LexVio work.{" "}<br /><em>In real time.</em></h2>
    </div>
    <p className="motion-sub rev d2">A sample vendor agreement — from upload to fully redlined — in a single sitting. An illustration of the steps the product runs.</p>
  </div>

  
  <div className="motion-tabs" id="motionTabs">
    <button className="mtab active" data-s="0"><span className="mtab-num">01</span>Upload</button>
    <button className="mtab" data-s="1"><span className="mtab-num">02</span>Scan</button>
    <button className="mtab" data-s="2"><span className="mtab-num">03</span>Analyze</button>
    <button className="mtab" data-s="3"><span className="mtab-num">04</span>Governing law</button>
    <button className="mtab" data-s="4"><span className="mtab-num">05</span>Redline</button>
  </div>

  
  <div className="motion-stage" id="motionStage">

    
    <div className="mscene active" data-s="0">
      <div className="mscene-text">
        <div className="mscene-num">01</div>
        <div className="mscene-label">Step 01</div>
        <h3 className="mscene-h">Drop any{" "}<br /><em>document.</em></h3>
        <p className="mscene-p">PDF, DOCX, plain text or a photo (JPEG, PNG), in English. A legacy .doc is refused with a message, never misread.</p>
        <div className="mscene-stat"><span className="mscene-stat-n">·</span><span className="mscene-stat-l">Parses in seconds, not hours</span></div>
      </div>
      <div className="mscene-visual">
        <div className="mvisual-window">
          <div className="mv-topbar"><div className="mv-dot" style={{"background":"#FF5F57"}}></div><div className="mv-dot" style={{"background":"#FFBD2E"}}></div><div className="mv-dot" style={{"background":"#28CA41"}}></div><span className="mv-title">lexvio.ai/upload</span></div>
          <div className="mv-body">
            <div className="upload-zone" id="uz">
              <div className="upload-icon"><svg fill="none" height="20" stroke="rgba(251,250,246,.4)" strokeWidth="1.4" viewBox="0 0 20 20" width="20"><path d="M10 14V6M7 9l3-3 3 3"/><path d="M3 16a2 2 0 002 2h10a2 2 0 002-2"/></svg></div>
              <div className="upload-title">Drop files here or click to upload</div>
              <div className="upload-sub">PDF, DOCX, TXT · Max 50MB</div>
            </div>
            <div className="upload-file" id="uf">
              <div className="upload-file-icon">PDF</div>
              <div><div className="upload-file-name">VendorAgreement_TechCorp.pdf</div><div className="upload-file-meta">2.4 MB · Uploaded just now</div></div>
            </div>
            <div className="upload-parse" id="uparse">
              <div className="upload-parse-text"><span>Parsing document…</span><span id="upc">0%</span></div>
              <div className="upload-parse-bar"><div className="upload-parse-fill" id="upfill"></div></div>
            </div>
            <div className="upload-stats">
              <div className="ustat" id="us1"><div className="ustat-n">34</div><div className="ustat-l">Pages</div></div>
              <div className="ustat" id="us2"><div className="ustat-n">47</div><div className="ustat-l">Clauses</div></div>
              <div className="ustat" id="us3"><div className="ustat-n">8,240</div><div className="ustat-l">Words</div></div>
            </div>
          </div>
        </div>
      </div>
    </div>

    
    <div className="mscene" data-s="1">
      <div className="mscene-text">
        <div className="mscene-num">02</div>
        <div className="mscene-label">Step 02</div>
        <h3 className="mscene-h">Every clause{" "}<br /><em>read.</em></h3>
        <p className="mscene-p">Every clause is read grounded in the contract&apos;s governing law, and each risk carries a confidence and a plain-English reason.</p>
        <div className="mscene-stat"><span className="mscene-stat-n">47</span><span className="mscene-stat-l">clauses examined</span></div>
      </div>
      <div className="mscene-visual">
        <div className="mvisual-window">
          <div className="mv-topbar"><div className="mv-dot" style={{"background":"#FF5F57"}}></div><div className="mv-dot" style={{"background":"#FFBD2E"}}></div><div className="mv-dot" style={{"background":"#28CA41"}}></div><span className="mv-title">Scanning 47 clauses…</span></div>
          <div className="mv-body" style={{"position":"relative"}}>
            <div className="scan-beam-mv" id="scanBeamMV"></div>
            <div className="scan-doc" id="scanDoc">
              <p><strong style={{"color":"rgba(251,250,246,.6)"}}>14. INDEMNIFICATION</strong></p>
              <p>The <span className="sclause" id="sc1">Vendor shall indemnify, defend, and hold harmless the Company from any and all claims, damages, losses, expenses, and legal fees arising out of or resulting from Vendor&apos;s performance,</span> without limitation of any kind.</p>
              <p style={{"marginTop":"10px"}}><strong style={{"color":"rgba(251,250,246,.6)"}}>8. INTELLECTUAL PROPERTY</strong></p>
              <p>All work product and <span className="sclause" id="sc2">developments created by Vendor, including all pre-existing intellectual property used in the work,</span> shall be assigned to Company in perpetuity.</p>
              <p style={{"marginTop":"10px"}}><strong style={{"color":"rgba(251,250,246,.6)"}}>21. TERMINATION</strong></p>
              <p>Either party may terminate this Agreement upon <span className="sclause" id="sc3">30 days written notice, without cause,</span> subject to payment of outstanding fees.</p>
            </div>
            <div className="scan-counter" id="scanCounter">
              <div className="scan-counter-dot"></div>
              <span id="scanCounterText">LexVio Legal Model v2.1 · Scanning…</span>
              <span className="scan-progress-num" id="scanNum">0</span>
            </div>
          </div>
        </div>
      </div>
    </div>

    
    <div className="mscene" data-s="2">
      <div className="mscene-text">
        <div className="mscene-num">03</div>
        <div className="mscene-label">Step 03</div>
        <h3 className="mscene-h">Every risk{" "}<br /><em>scored.</em></h3>
        <p className="mscene-p">Critical issues highlighted. Fix suggestions generated. Legal Health Score calculated. One complete, actionable report — instantly.</p>
        <div className="mscene-stat"><span className="mscene-stat-n" id="rdScoreStat">0</span><span className="mscene-stat-l">/100 Legal Health Score</span></div>
      </div>
      <div className="mscene-visual">
        <div className="mvisual-window">
          <div className="mv-topbar"><div className="mv-dot" style={{"background":"#FF5F57"}}></div><div className="mv-dot" style={{"background":"#FFBD2E"}}></div><div className="mv-dot" style={{"background":"#28CA41"}}></div><span className="mv-title">Risk Analysis — Complete</span></div>
          <div className="mv-body" style={{"padding":"16px"}}>
            <div className="risk-dash">
              <div className="rd-score">
                <div className="rd-score-arc">
                  <svg className="rd-score-svg" viewBox="0 0 80 80"><circle cx="40" cy="40" fill="none" r="32" stroke="rgba(251,250,246,.06)" strokeWidth="6"/><circle cx="40" cy="40" fill="none" id="rdArcFill" r="32" stroke="#B86E2C" strokeDasharray="201" strokeDashoffset="201" strokeLinecap="round" strokeWidth="6" style={{"transition":"stroke-dashoffset 1.4s cubic-bezier(.76,0,.24,1)"}} transform="rotate(-90 40 40)"/></svg>
                  <div className="rd-score-num" id="rdScore">0</div>
                </div>
                <div className="rd-score-info">
                  <div className="rd-score-label">Legal Health Score</div>
                  <div className="rd-score-verdict">High Risk — 3 critical issues</div>
                  <div className="rd-score-sub">Fix suggestions available below</div>
                </div>
              </div>
              <div className="rd-card" id="rdc1">
                <div className="rd-card-label">Risk breakdown</div>
                <div className="rd-bar-row"><span className="rd-bar-lbl">Liability</span><div className="rd-bar-t"><div className="rd-bar-f" data-w="82%" style={{"background":"var(--red)"}}></div></div></div>
                <div className="rd-bar-row"><span className="rd-bar-lbl">IP coverage</span><div className="rd-bar-t"><div className="rd-bar-f" data-w="59%" style={{"background":"var(--amber)"}}></div></div></div>
                <div className="rd-bar-row"><span className="rd-bar-lbl">Govern. law</span><div className="rd-bar-t"><div className="rd-bar-f" data-w="90%" style={{"background":"var(--green)"}}></div></div></div>
                <div className="rd-bar-row"><span className="rd-bar-lbl">Termination</span><div className="rd-bar-t"><div className="rd-bar-f" data-w="55%" style={{"background":"var(--amber)"}}></div></div></div>
              </div>
              <div className="rd-card" id="rdc2" style={{"gridColumn":"1/-1"}}>
                <div className="rd-card-label">Critical findings</div>
                <div className="rd-risk-item" id="rri1"><div className="rd-risk-dot" style={{"background":"var(--red)"}}></div><div className="rd-risk-text">§14 — Liability cap absent. Unlimited exposure without monetary limit.</div><div className="rd-risk-badge rdb-r">CRITICAL</div></div>
                <div className="rd-risk-item" id="rri2"><div className="rd-risk-dot" style={{"background":"var(--red)"}}></div><div className="rd-risk-text">§8 — IP assignment overbroad. Includes all pre-existing vendor IP.</div><div className="rd-risk-badge rdb-r">CRITICAL</div></div>
                <div className="rd-risk-item" id="rri3"><div className="rd-risk-dot" style={{"background":"var(--amber)"}}></div><div className="rd-risk-text">§21 — Termination without cause. 30 days notice non-standard.</div><div className="rd-risk-badge rdb-a">REVIEW</div></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    
    <div className="mscene" data-s="3">
      <div className="mscene-text">
        <div className="mscene-num">04</div>
        <div className="mscene-label">Step 04</div>
        {/* Was a case-law search over House of Lords / EWHC / EWCA "samples" —
            legal research is an India-only surface and 404s on this product,
            and one sample attached an invented holding to a real case name.
            Replaced 2026-09-18 with what this product does: read the governing
            law from the clause and check the applicable-law notes at the
            official statute source. Ids and classes unchanged; ClientScripts'
            animScene3 types the query and reveals rc1–rc3 as before. */}
        <h3 className="mscene-h">Governing law.{" "}<br /><em>Checked at the source.</em></h3>
        <p className="mscene-p">The governing-law clause decides which law applies — never a guess — and the analysis is grounded in that law. The jurisdiction notes LexVio publishes are checked, provision by provision, at the official statute register before a named person signs them off. The provisions shown are samples.</p>
        <div className="mscene-stat"><span className="mscene-stat-n">3</span><span className="mscene-stat-l">sample provisions, three verdicts</span></div>
      </div>
      <div className="mscene-visual">
        <div className="mvisual-window">
          <div className="mv-topbar"><div className="mv-dot" style={{"background":"#FF5F57"}}></div><div className="mv-dot" style={{"background":"#FFBD2E"}}></div><div className="mv-dot" style={{"background":"#28CA41"}}></div><span className="mv-title">Statute Check · Illustrative</span></div>
          <div className="mv-body">
            <div className="research-search">
              <span className="research-search-icon">⌕</span>
              <span className="research-search-text" id="researchQuery"></span><span className="research-search-cursor"></span>
            </div>
            <div className="research-status"><div className="research-status-dot"></div><span id="researchStatus">Checking at the source…</span></div>
            <div className="rcase" id="rc1">
              <div className="rcase-court">legislation.gov.uk · sample</div>
              <div className="rcase-name">Unfair Contract Terms Act 1977, s.2(1)</div>
              <div className="rcase-snippet">Liability for death or personal injury resulting from negligence cannot be excluded or restricted by a contract term…</div>
              <div className="rcase-rel">⭢ Verified · provision retrieved, claim terms present</div>
            </div>
            <div className="rcase" id="rc2">
              <div className="rcase-court">CELLAR (EU Publications Office) · sample</div>
              <div className="rcase-name">GDPR, Article 28(3)</div>
              <div className="rcase-snippet">Processing by a processor shall be governed by a contract that sets out the subject-matter, duration, nature and purpose of the processing…</div>
              <div className="rcase-rel">⭢ Verified · article retrieved by CELEX</div>
            </div>
            <div className="rcase" id="rc3">
              <div className="rcase-court">wetten.overheid.nl · sample</div>
              <div className="rcase-name">Burgerlijk Wetboek, Boek 6, art. 248</div>
              <div className="rcase-snippet">Article located. No official English text exists, so the wording cannot be compared — the claim stays unverified…</div>
              <div className="rcase-rel">⭢ Unverified · exists, not confirmed</div>
            </div>
          </div>
        </div>
      </div>
    </div>

    
    <div className="mscene" data-s="4">
      <div className="mscene-text">
        <div className="mscene-num">05</div>
        <div className="mscene-label">Step 05</div>
        <h3 className="mscene-h">Redlined.{" "}<br /><em>Ready to send.</em></h3>
        <p className="mscene-p">AI generates precise redlines grounded in the contract&apos;s governing law. One click to apply, or share with your counterparty. The follow-ups become tasks on the matter, and the matter timeline records them.</p>
        <div className="mscene-stat"><span className="mscene-stat-n">2</span><span className="mscene-stat-l">critical issues resolved</span></div>
      </div>
      <div className="mscene-visual">
        <div className="mvisual-window">
          <div className="mv-topbar"><div className="mv-dot" style={{"background":"#FF5F57"}}></div><div className="mv-dot" style={{"background":"#FFBD2E"}}></div><div className="mv-dot" style={{"background":"#28CA41"}}></div><span className="mv-title">AI Redlined Draft · v2</span></div>
          <div className="mv-body">
            <div className="redline-doc">
              <p><strong style={{"color":"rgba(251,250,246,.55)"}}>14. INDEMNIFICATION</strong></p>
              <div className="redline-change" id="rl1">
                <p><span className="rl-old">Vendor shall indemnify, defend, and hold harmless the Company from any and all claims, damages, losses, expenses, and legal fees arising out of or resulting from Vendor&apos;s performance, without limitation of any kind.</span></p>
                <p style={{"marginTop":"6px"}}><span className="rl-new">Vendor shall indemnify Company from direct claims arising from Vendor&apos;s wilful misconduct or gross negligence, capped at total fees paid in the preceding 12 months.</span> <span style={{"fontSize":"9px","color":"rgba(251,250,246,.22)"}}>[illustrative citation]</span></p>
              </div>
              <p style={{"marginTop":"10px"}}><strong style={{"color":"rgba(251,250,246,.55)"}}>8. INTELLECTUAL PROPERTY</strong></p>
              <div className="redline-change" id="rl2">
                <p><span className="rl-old">All work product and developments, including all pre-existing intellectual property used in the work, shall be assigned to Company in perpetuity.</span></p>
                <p style={{"marginTop":"6px"}}><span className="rl-new">Work product created specifically under this Agreement shall be assigned to Company. Vendor&apos;s pre-existing IP is expressly excluded from this assignment.</span> <span style={{"fontSize":"9px","color":"rgba(251,250,246,.22)"}}>[illustrative citation]</span></p>
              </div>
            </div>
            <div className="redline-status" id="rlStatus">
              <span>✓ 2 critical issues resolved · Contract ready</span>
              <div className="rl-share-btn">Share draft →</div>
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>

  
  <div className="motion-progress-wrap">
    <div style={{"display":"flex","alignItems":"center","justifyContent":"space-between","marginBottom":"10px"}}>
      <div className="motion-progress-dots" id="motionDots">
        <div className="mpd active"></div>
        <div className="mpd"></div>
        <div className="mpd"></div>
        <div className="mpd"></div>
        <div className="mpd"></div>
      </div>
      <div className="motion-time" id="motionTime">01 / 05</div>
    </div>
    <div className="motion-progress-bar">
      <div className="motion-progress-fill" id="motionFill"></div>
    </div>
    <div className="motion-controls">
      <button className="motion-ctrl-btn" id="prevBtn">← Prev</button>
      <button className="motion-ctrl-btn" id="pauseBtn">⏸ Pause</button>
      <button className="motion-ctrl-btn" id="nextBtn">Next →</button>
      <span style={{"marginLeft":"auto","fontSize":"11px","color":"rgba(251,250,246,.18)","letterSpacing":".04em"}}>AUTO-ADVANCING · HOVER TO PAUSE</span>
    </div>
  </div>
</section>


    </>
  );
}
